import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { ActionButton, PreviousButton } from '@/components/Button';

interface IndigentFormFooterProps {
    onBack: () => void;
    onNext: () => void;
    isLastStep: boolean;
    activeStep: number;
    disableNext: boolean;
    isLoading?: boolean;
    isEditable?: boolean;
    mode?: 'create' | 'edit';
}

const IndigentFormFooter: React.FC<IndigentFormFooterProps> = ({
    onBack,
    onNext,
    isLastStep,
    activeStep,
    disableNext,
    isLoading = false,
    isEditable = true,
    mode = 'create',
}) => {
    return (
        <Box display='flex' justifyContent='flex-end' gap={2}>
            {activeStep > 0 && (
                <PreviousButton
                    onClick={onBack}
                    startIcon={<span style={{ color: '#FF544B' }}>↩</span>}
                    disabled={isLoading}
                >
                    Previous Page
                </PreviousButton>
            )}
            <ActionButton 
                onClick={onNext} 
                disabled={disableNext || isLoading}
                startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : undefined}
            >
                {isLastStep 
                    ? (isEditable ? 'Submit Indigent' : 'Review Complete') 
                    : 'Next Step'
                }
            </ActionButton>
        </Box>
    );
};

export default IndigentFormFooter;
